export default {
  isActive: (state, path) => {
    return (typeof(state.current) != 'undefined') ? state.current.indexOf(path) > -1 : false;
  }
}